import { render } from "./CorregirDiagCantidad.vue?vue&type=template&id=11734c8f&scoped=true"
import script from "./CorregirDiagCantidad.vue?vue&type=script&lang=js"
export * from "./CorregirDiagCantidad.vue?vue&type=script&lang=js"

import "./CorregirDiagCantidad.vue?vue&type=style&index=0&id=11734c8f&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11734c8f"]])

export default __exports__